import { useEffect } from 'react';

// @ts-ignore
import { StudentSubjectsQuery } from '@school_ify/schoolify-repository/src/student/types';

import HeaderService from 'domain/services/student/header';
import { addClasses, addActiveClass } from 'redux/header/actions';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { getHeaderActiveClass, getHeaderClasses } from 'redux/header/selectors';

export default function useHeaderClasses() {
  const classes = useAppSelector(getHeaderClasses);
  const activeSubject = useAppSelector(getHeaderActiveClass);
  const dispatch = useAppDispatch();

  async function initHeaderClasses() {
    const { subjects } = await HeaderService.getHeaderClasses();
    if (subjects) {
      const active = subjects[0];
      // @ts-ignore
      dispatch(addActiveClass(active));
      // @ts-ignore
      dispatch(addClasses(subjects));
    }
  }

  useEffect(() => {
    initHeaderClasses();
  }, []);

  function setActiveSubject(subject: StudentSubjectsQuery) {
    dispatch(addActiveClass(subject));
  }

  return {
    classes,
    activeSubject,
    setActiveSubject,
  };
}
